import React from 'react';
import SvgIcon from '../SvgIcon';

/* this is an SVG converted to JSX */

export default function PopularTopicsIcon(props) {
    return (
        <SvgIcon {...props} aria-hidden={true}>
            <g id="popular_topics" data-name="popular topics">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none">
                    <path fill="none" d="M0 0H32V32H0z"></path>
                    <path
                        stroke="#282C36"
                        d="M22.622 2.503h.226c3.773.11 6.652 2.962 6.652 6.547v8.791c0 3.86-3.17 7.104-6.878 7.104H17.876l-.114.063-7.955 4.45h-.001a.314.314 0 01-.311 0h-.002a.313.313 0 01-.156-.272v-4.223l-.467-.03c-3.47-.227-6.37-3.367-6.37-7.088V9.053c0-3.662 2.955-6.55 6.773-6.55h13.35z"
                    ></path>
                    <path
                        stroke="#282C36"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M16.552 6.861l1.932 4.668 4.815.485-3.625 3.373 1.05 4.968-4.172-2.582-4.17 2.582 1.048-4.968-3.625-3.373 4.815-.485 1.932-4.668z"
                    ></path>
                </svg>
            </g>
        </SvgIcon>
    );
}
